export default async function ({ $auth0, route, redirect }) {
    if ($auth0.isAuthenticated && $auth0.isInRole('kiosk')) {
        return redirect('/timeclock');
    }

    return;
}